import { useState } from 'react'
import { Switch as HeadlessSwitch } from '@headlessui/react'

type Props = {
  enabled: boolean
  onChange: (enabled: boolean) => void
}

export default function Switch(props: Props) {

  return (
      <HeadlessSwitch
        checked={props.enabled}
        onChange={enabled => props.onChange(enabled)}
        className={`${props.enabled ? 'bg-accent' : 'bg-gray-500'}
          relative inline-flex flex-shrink-0 h-6 w-[60px] border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus-visible:ring-2  focus-visible:ring-white focus-visible:ring-opacity-75`}
      >
        <span className="sr-only">All Regions</span>
        <span
          aria-hidden="true"
          className={`${props.enabled ? 'translate-x-9' : 'translate-x-0'}
            pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow-lg transform ring-0 transition ease-in-out duration-200`}
        />
      </HeadlessSwitch>
  )
}
